var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animation-container",class:{ horizontal: _vm.horizontal, paused: _vm.paused },on:{"click":function($event){_vm.paused = !_vm.paused}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }